"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var defaultAssertStatusCode = function (assertStatusCodes) { return function (statusCode) {
    return assertStatusCodes.includes(statusCode);
}; };
exports.mergeLayersSettings = function (settings, userSettings, telemetry, assertStatusCodes) {
    if (userSettings === void 0) { userSettings = {}; }
    var timeout = ramda_1.pathOr(settings.timeout, ['timeout'], userSettings);
    var failureTreshold = ramda_1.pathOr(settings.failureTreshold, ['circuitBreaker', 'failureTreshold'], userSettings);
    var samplingDuration = ramda_1.pathOr(settings.samplingDuration, ['circuitBreaker', 'samplingDuration'], userSettings);
    var minimumSamples = ramda_1.pathOr(settings.minimumSamples, ['circuitBreaker', 'minimumSamples'], userSettings);
    var maximumSamples = ramda_1.pathOr(settings.maximumSamples, ['circuitBreaker', 'maximumSamples'], userSettings);
    var openDuration = ramda_1.pathOr(settings.openDuration, ['circuitBreaker', 'openDuration'], userSettings);
    var maxTimeForHalfOpenRequest = ramda_1.pathOr(settings.maxTimeForHalfOpenRequest, ['circuitBreaker', 'maxTimeForHalfOpenRequest'], userSettings);
    //tslint:disable-next-line:no-unbound-method
    var hashFunction = ramda_1.pathOr(settings.hashFunction, ['circuitBreaker', 'hashFunction'], userSettings);
    //tslint:disable-next-line:no-unbound-method
    var defaultStatusCode = assertStatusCodes ? defaultAssertStatusCode(assertStatusCodes) : settings.assertStatusCode;
    var assertStatusCode = ramda_1.pathOr(defaultStatusCode, ['assertStatusCode'], userSettings);
    return {
        timeoutConfig: {
            timeout: timeout,
        },
        circuitBreakerConfig: {
            failureTreshold: failureTreshold,
            samplingDuration: samplingDuration,
            minimumSamples: minimumSamples,
            maximumSamples: maximumSamples,
            openDuration: openDuration,
            maxTimeForHalfOpenRequest: maxTimeForHalfOpenRequest,
            hashFunction: hashFunction,
        },
        badStatusCodeConfig: {
            assertStatusCode: assertStatusCode,
        },
        telemetryLogger: telemetry,
    };
};
//# sourceMappingURL=mergeLayersSettings.js.map